<form [formGroup]="busqueda">
    <nav class="navbar navbar-light bg-light navbar-expand-lg mb-3">
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto">
                <li class="nav-item ms-4 mt-2 me-2">
                    <p>Año:</p>
                </li>
                <!-- Año -->
                <li class="nav-item me-2">
                    <input [attr.disabled]="this.cargandoReporte ? '': null" type="number" min="2020" max="{{max}}"
                        id="anio" formControlName="anioFormControl" class="form-control" style="width: 100px;">
                </li>

                <li class="nav-item me-2">
                    <button (click)="obtenerListaReportes()" class="btn btn-outline-primary">
                        <i class="fa fa-search"></i>
                    </button>
                </li>
            </ul>
        </div>
    </nav>
</form>
<div *ngIf="listaReportes">
    <ngb-alert [dismissible]="false" *ngIf="listaReportes.length == 0 && !cargandoReporte">
        No existen reportes para el año seleccionado
    </ngb-alert>
    <table *ngIf="listaReportes.length !== 0 && !cargandoReporte" class="table table-striped">
        <thead>
            <th></th>
            <th class="text-center">Mes</th>
            <th class="text-center">Fecha</th>
            <th class="text-center">Descargar</th>
        </thead>
        <tbody>
            <tr *ngFor="let r of listaReportes">
                <th></th>
                <td class="text-center">{{r.mes}}</td>
                <td class="text-center">{{r.desdeHasta}}</td>
                <td class="text-center"><a class="btn btn-outline-primary mt-2" style="border-radius: 60%"
                        href="{{r.link}}">
                        <i class="fa fa-download" aria-hidden="true"></i>
                    </a></td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="cargandoReporte" class="spinner-container">
        <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd Color="rgba(193,193,193,0)" size="medium" color="#185db5"
            type="ball-grid-beat" [fullScreen]="false">
            <p style="color: white">C a r g a n d o . . . </p>
        </ngx-spinner>
    </div>
</div>